"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M28.023 4.36A.965.965 0 0 0 27.98 3a.963.963 0 0 0-1.362-.044 1.373 1.373 0 0 0-.118.144l-.012-.015-8.739 8.735.012.016a.68.68 0 0 0-.145.119.995.995 0 0 0 1.4 1.4.916.916 0 0 0 .119-.145l.013.013 8.739-8.738-.015-.013a.847.847 0 0 0 .151-.112zM29.8 5.883c-.721.721-9.538 9.645-9.589 9.7a2.214 2.214 0 0 1-2.362.029l-.767-.725L6.286 25.474a1.5 1.5 0 0 0-.327.48L4.088 32.36a.375.375 0 0 0 .495.491l6.433-1.956a1.5 1.5 0 0 0 .46-.312L33.06 9.079zm1.014-1.711l3.106 2.956a2.78 2.78 0 0 0-.807-3.228 3.3 3.3 0 0 0-3.22-1.06c-.179.064.065.3.138.375s.735.861.783.957zM3.723 27.486c-3.054-9.06.3-16.932 8.725-21.51 1.269-.69.268-2.706-1.009-2.011C2.19 8.992-1.077 17.405 2.286 27.5c1.437 4.314 1.437-.014 1.437-.014z" })
);

